export default function getResource(label, vars = []) {
    const resources = {
        cardTitle: 'Payment',
        expires: 'Exp',
        useGiftCard: 'Use a Gift Card',
        paypalRestrictedItemError: 'You have an item in Basket that cannot be purchased using PayPal. Please remove the item to continue checking out with PayPal or use a different payment method to continue checking out with the item.',
        giftCardNumber: 'Gift card number',
        pin: 'PIN',
        applyBtn: 'Apply',
        cancelBtn: 'Cancel',
        maxGiftCards: 'You’ve reached the maximum number of gift cards you can use for this order.',
        giftCard: 'Gift Card',
        applied: 'applied',
        remove: 'Remove',
        secure: 'Secure',
        payPalAccount: 'PayPal Account',
        payWithPayPal: 'Pay with PayPal',
        payNow: 'Pay now',
        or: 'or',
        payLaterWithPayPal: 'Pay Later with PayPal',
        payWithApplePay: 'Pay with ApplePay',
        addNewCreditCard: 'Add new credit or debit card',
        addNewCard: 'Add New Card',
        useThisCard: 'Use This Card',
        useThisPaymentMethod: 'Use This Payment Method',
        debitCardDisclaimer: 'Visa and Mastercard debit cards only',
        payPalDisabled: 'PayPal cannot be used when purchasing a subscription.',
        verifyCVV: 'No payment is required, please verify your CVV/CVC number for security purposes.',
        accountCredit: 'Account Credit',
        giftCardsNotCombinable: 'Gift cards are not combinable with this payment type.',
        removeCreditCard: 'Remove Credit or Debit Card?',
        areYouSureMessage: 'Are you sure you would like to permanently remove this card?',
        removeGiftCard: 'Remove Gift Card',
        areYouSureGiftCardMessage: 'Are you sure you would like to remove this gift card from your order?',
        cancel: 'Cancel',
        expiredCreditCardMsg: 'This card is expired. Please update your card information.',
        edit: 'Edit',
        gotIt: 'Got It',
        cvc: 'CVV/CVC',
        moreInfoCvc: 'More info about CVV',
        showAll: 'Show all',
        showLess: 'Show less',
        storeCreditApplied: 'Account Credit',
        storeCreditNotEnoughMessage: 'Your Account Credit is less than the order total. Please add an additional payment method.',
        accountCreditAltText: 'Sephora Account Credit',
        paymentMethodSelection: 'Payment Method Selection',
        paymentInformation: 'Payment Information',
        removeAddress: 'Remove address',
        maxCreditCardsMessage: `You can have up to ${vars[0]} credit cards. Please delete one and try to add again.`,
        continueButton: 'Continue',
        editPaypal: 'Edit',
        otherWaysToPay: 'Other Ways to Pay',
        interestFreeMessage: `Or pay in 4 interest-free payments of ${vars[0]} with ${vars[1]}.`,
        orPayInFour: 'Or pay in 4 interest-free payments of',
        payWith: 'Pay with',
        installmentsMessage: `4 interest-free payments of ${vars[0]}`,
        availableWith: 'avaliable with',
        afterpayHeader: 'Pay with Cash App Afterpay',
        afterpayHeaderCA: 'Afterpay',
        afterpaySubtitle: `4 interest-free payments of ${vars[0]}`,
        afterpaySaveAndContinue: 'Save and Continue',
        afterpayCancel: 'Cancel',
        afterpayContinueWithAfterpay: 'Continue with Afterpay',
        afterpayLoading: 'Loading Afterpay details...',
        afterpayErrorMessage: 'Unable to load Afterpay information. Please try again.',
        afterpayApiErrorFallback: 'Split your payment into 4 interest-free installments with Afterpay.',
        afterpayGiftCardWarning: 'Gift cards are not combinable with Cash App Afterpay. If you want to use a gift card, please select another payment method.',
        afterpayLegalNotice: 'By clicking Continue to Cash App Afterpay, I am instructing Sephora to send my order and billing information to Afterpay and understand that information will be subject to Afterpay\'s <a href=\'https://www.afterpay.com/en-US/terms-of-service\' target=\'_blank\'>terms</a> and <a href=\'https://www.afterpay.com/en-US/privacy-policy\' target=\'_blank\'>privacy policy</a>.',
        venmoHeader: 'Pay with Venmo',
        venmoSaveAndContinue: 'Save and Continue',
        klarnaHeader: 'Pay with Klarna',
        klarnaSaveAndContinue: 'Save and Continue',
        klarnaCancel: 'Cancel',
        klarnaLoading: 'Loading Klarna payment options...',
        klarnaApiErrorFallback: 'Unable to load Klarna payment information. Please try again or choose another payment method.',
        klarnaTimeoutError: 'Request timed out. Please try again.',
        klarnaNetworkError: 'Network error. Please check your connection and try again.',
        klarnaSubtitle: `Pay with 4 interest-free payments of ${vars[0]}`,
        klarnaGiftCardWarning: 'Gift cards are not combinable with Klarna. If you want to use a gift card, please select another payment method.',
        klarnaFeatureBuyerProtection: 'Enjoy <a href="https://www.klarna.com/us/buyer-protection/" target="_blank">Buyer protection</a> with Klarna. See <a href="https://www.klarna.com/us/customer-service/" target="_blank">Payment options.</a>',
        klarnaTermsText: 'By continuing I accept the <a href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/sliceitinx" target="_blank">Klarna Shopping Service Terms</a> and <a href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/privacy" target="_blank">Klarna Privacy Notice,</a> and confirm that I have read the <a href="https://www.klarna.com/us/legal/" target="_blank">Klarna Cookie Notice.</a>',
        klarnaLegalNotice: 'By clicking Continue to Klarna, I am instructing Sephora to send my order and billing information to Klarna and understand that information will be subject to the Klarna terms and the Klarna privacy policy.',
        klarnaBillingAddressCheckbox: 'My billing address is the same as my shipping address',
        pazeHeader: 'Pay with Paze',
        pazeSubtitle: 'Available for consumers of participating banks and credit unions',
        pazeGiftCardWarning: 'Gift cards are not combinable with Paze. If you want to use a gift card, please select another payment method.',
        pazeSaveAndContinue: 'Save and Continue',
        pazeCancel: 'Cancel',
        giftCardNumberPlaceholder: 'Card Number',
        pinNumberPlaceholder: 'PIN Number',
        nonCombinableGiftCardPartners: 'Klarna, Afterpay and Paze options cannot be combinable with gift cards.',
        giftCardAdditionalPaymentRequired: 'Your Gift Card credit is less than the order total. Please add an additional payment method.',
        and: ' and ',
        cantUseForThisOrder: 'cannot be used for this order.',
        cannotBeCombinedWithGiftCards: 'cannot be combined with gift cards.',
        cannotBeUsedWhenPurchasingGiftCards: 'cannot be used when purchasing gift cards.',
        seeDetails: 'See details',
        alternatePaymentDetailsTitle: 'Alternate payment details',
        alternatePaymentDetailsMessage: 'Details about unavailable payment methods.',
        ok: 'OK',
        deleteCard: 'Delete Card'
    };

    return resources[label];
}
